import React from "react";
import Card from "../components/ui/Card";
import Button from "../components/ui/Button";
import DriverPickupsList from "../components/driver/DriverPickupsList";
import DriverPickupsWeek from "../components/driver/DriverPickupsWeek";
import type { Pickup } from "../types/pickup";

const pageStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
};

const headingRowStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "16px",
  flexWrap: "wrap",
};

const titleStyle: React.CSSProperties = {
  margin: 0,
  fontSize: "24px",
  fontWeight: 800,
  color: "var(--text-primary)",
};

const descriptionStyle: React.CSSProperties = {
  margin: "6px 0 0",
  fontSize: "14px",
  lineHeight: 1.5,
  color: "var(--text-secondary)",
};

const weekControlsStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  flexWrap: "wrap",
};

const weekLabelStyle: React.CSSProperties = {
  minHeight: "42px",
  padding: "0 14px",
  borderRadius: "14px",
  border: "1px solid var(--border)",
  background: "var(--surface-alt)",
  color: "var(--text-primary)",
  display: "flex",
  alignItems: "center",
  fontSize: "13px",
  fontWeight: 700,
};

const summaryGridStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))",
  gap: "12px",
};

const summaryCardStyle: React.CSSProperties = {
  minHeight: "138px",
  display: "flex",
  alignItems: "center",
  gap: "16px",
};

const summaryIconStyle = (
  color: string
): React.CSSProperties => ({
  width: "54px",
  height: "54px",
  minWidth: "54px",
  borderRadius: "18px",
  border: `1px solid ${color}`,
  background: "var(--surface-alt)",
  color,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "22px",
  fontWeight: 800,
});

const summaryLabelStyle: React.CSSProperties = {
  color: "var(--text-secondary)",
  fontSize: "13px",
  marginBottom: "6px",
};

const summaryValueStyle: React.CSSProperties = {
  color: "var(--text-primary)",
  fontSize: "24px",
  fontWeight: 800,
  lineHeight: 1.2,
};

const summaryHelperStyle: React.CSSProperties = {
  color: "var(--text-secondary)",
  fontSize: "12px",
  marginTop: "7px",
  lineHeight: 1.4,
};

const DriverPickups = () => {
  /*
   * La entidad Pickup ya está preparada en el proyecto.
   * Hasta conectar una fuente real, no mostramos métricas inventadas.
   */
  const pickups: Pickup[] = [];

  return (
    <div style={pageStyle}>
      <div style={headingRowStyle}>
        <div>
          <h1 style={titleStyle}>Mis colectas</h1>

          <p style={descriptionStyle}>
            Seguimiento semanal de colectas y estados operativos.
          </p>
        </div>

        <div style={weekControlsStyle}>
          <Button variant="secondary" aria-label="Semana anterior">
            ‹
          </Button>

          <div style={weekLabelStyle}>Semana actual</div>

          <Button variant="secondary" aria-label="Semana siguiente">
            ›
          </Button>

          <div style={weekLabelStyle}>Período pendiente de integración</div>
        </div>
      </div>

      <div style={summaryGridStyle}>
        <Card style={summaryCardStyle}>
          <div style={summaryIconStyle("var(--success)")}>✓</div>

          <div>
            <div style={summaryLabelStyle}>Colectas realizadas</div>
            <div style={summaryValueStyle}>—</div>
            <div style={summaryHelperStyle}>Sin información disponible</div>
          </div>
        </Card>

        <Card style={summaryCardStyle}>
          <div style={summaryIconStyle("var(--success)")}>◷</div>

          <div>
            <div style={summaryLabelStyle}>A horario</div>
            <div style={summaryValueStyle}>—</div>
            <div style={summaryHelperStyle}>Pendiente de horarios reales</div>
          </div>
        </Card>

        <Card style={summaryCardStyle}>
          <div style={summaryIconStyle("var(--primary)")}>$</div>

          <div>
            <div style={summaryLabelStyle}>Pago por colectas</div>
            <div style={summaryValueStyle}>—</div>
            <div style={summaryHelperStyle}>Pendiente de liquidación</div>
          </div>
        </Card>

        <Card style={summaryCardStyle}>
          <div style={summaryIconStyle("var(--primary)")}>☆</div>

          <div>
            <div style={summaryLabelStyle}>Presentismo y premio semanal</div>
            <div style={summaryValueStyle}>Pendiente</div>
            <div style={summaryHelperStyle}>
              A validar con el control actual de presentismo
            </div>
          </div>
        </Card>
      </div>

      <DriverPickupsWeek weekOffset={0} />
      
      <DriverPickupsList pickups={pickups} />
    </div>
  );
};

export default DriverPickups;